import Navbar from "@/components/Navbar";
import CookieBanner from "@/components/CookieBanner";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import PlugAndBarSection from "@/components/PlugAndBarSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import PartnersSection from "@/components/PartnersSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ExperiencesSection from "@/components/ExperiencesSection";

export default function HomePage() {
  return (
    <div className="relative min-h-screen bg-background-50">
      {/* Subtle ambient gradient background — coral & cream tones */}
      <div className="fixed inset-0 z-0 bg-gradient-to-br from-primary-500/4 via-background-50 to-accent-200/20" />

      {/* Animated floating light orbs — coral & warm tones */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div
          className="absolute w-[500px] h-[500px] rounded-full animate-orb-1 animate-glow-pulse"
          style={{
            background:
              "radial-gradient(circle, rgba(234,81,73,0.05) 0%, transparent 70%)",
            top: "10%",
            left: "-5%",
          }}
        />
        <div
          className="absolute w-[400px] h-[400px] rounded-full animate-orb-2 animate-glow-pulse"
          style={{
            background:
              "radial-gradient(circle, rgba(242,135,82,0.06) 0%, transparent 70%)",
            top: "50%",
            right: "-10%",
            animationDelay: "2s",
          }}
        />
        <div
          className="absolute w-[350px] h-[350px] rounded-full animate-orb-3 animate-glow-pulse"
          style={{
            background:
              "radial-gradient(circle, rgba(234,81,73,0.03) 0%, transparent 70%)",
            bottom: "15%",
            left: "40%",
            animationDelay: "4s",
          }}
        />
        <div
          className="absolute w-24 h-24 rounded-full animate-orb-1"
          style={{
            background:
              "radial-gradient(circle, rgba(242,135,82,0.04) 0%, transparent 70%)",
            top: "25%",
            right: "20%",
          }}
        />
        <div
          className="absolute w-32 h-32 rounded-full animate-orb-2"
          style={{
            background:
              "radial-gradient(circle, rgba(234,81,73,0.02) 0%, transparent 70%)",
            bottom: "35%",
            left: "15%",
          }}
        />
      </div>

      {/* Subtle noise texture */}
      <div
        className="fixed inset-0 z-0 opacity-[0.02] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      <Navbar />
      <main className="relative z-10">
        <HeroSection />
        <ExperiencesSection />
        <AboutSection />
        <ServicesSection />
        <WhyChooseSection />
        <PlugAndBarSection />
        <PartnersSection />
        <ContactSection />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}